module.exports = __webpack_public_path__ + "static/img/btn2.d3e02928.png";